import React, { Component } from 'react';




export default class CancelModal extends Component {
    // constructor() {
    //     super()
    // }

    render() {
        if (this.props.isModalOpen === true) {
            return (
                <div class="modal" style={{ display: 'block' }} id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
                    <div class="modal-dialog friendly-calls-modal" role="document">
                        <div class="modal-content">
                            <div className='delete-modal'>
                            <h4>Cancel Booking</h4>
                            <p>Are you sure you want to cancel this Session</p>
                            <div className='delete-modal-btn'>
                            <button type='button' class="btn cnfrm-btn" onClick={()=>this.props.CancelSession()}>Confirm</button>
                            <button type='button' class="btn cancl-btn"onClick={()=>this.props.CloseCancelModal()}>Cancel</button>
                            </div>
                            </div>

                           
                        </div>
                    </div>
                </div>
            )
        }
        else return null
    }
}